
export const environment: any = {
  "hostname": 'qa.cblrd.lexus.com',
  "production":false,
  "baseLoginUrl": "https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=1667105f-2920-47ea-9e03-3042047af069&response_type=code&redirect_uri=https://qa.cblrd.lexus.com&response_mode=query&scope=openid&state=23343&code_challenge=",
  "tokenURL": "https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token",
  "logoutUrl": "https://login.microsoftonline.com/common/oauth2/logout",
  "grantType": "authorization_code",
  "clientId": "1667105f-2920-47ea-9e03-3042047af069",
  "redirectURI": "https://qa.cblrd.lexus.com",
  "region": "us-west-2",
  "turnOverReport": "https://api.qa.cblrd.lexus.com/qa_dashboard/",
  "aseReport":"https://api.qa.cblrd.lexus.com/qa_ase_reports/",
  "jobEnrollment":"https://api.qa.cblrd.lexus.com/qa_job_enrollment/",
  "dealerTrainingBilling":"https://api.qa.cblrd.lexus.com/qa_dealers_billing/",
  "elevateBilling":"https://api.qa.cblrd.lexus.com/qa_elevate_billing/",
  "eventBilling":"https://api.qa.cblrd.lexus.com/qa_event_billing/",  
  "staffMaster":"https://api.qa.cblrd.lexus.com/qa_staff_master/",
  "UserAccess": "https://api.qa.cblrd.lexus.com/qa_access_control/",
  "tenure":"https://api.qa.cblrd.lexus.com/qa_tenure_api/",
  "eventDashboard": "https://api.qa.cblrd.lexus.com/qa_event_dashboard/",
  "eliteCertification":"https://api.qa.cblrd.lexus.com/qa_elite_certification/",
  "impactAnalysis":"https://api.qa.cblrd.lexus.com/qa_impact_analysis/",
  "dealerScorecard":"https://jn7r7nqslg.execute-api.us-west-2.amazonaws.com/dev/"
};

export const applyConfig = (config: any) => {
  Object.assign(environment, config);
};
